<template>
  <template v-for="chat in list">
    <chat-widget :name="chat.name" :order_id="chat.id" :chat_id="chat.chat_id"
                 :startX="chat.startX" :startY="chat.startY"
                 :idx="chat.idx" @closeChat="closeChat"></chat-widget>
  </template>
</template>

<script>
  import ChatWidget from './ChatWidget';

  export default {
    name      : 'ChatWidgetList',
    components: {ChatWidget},
    props     : [],
    mounted() {
      window.openChat = this.addChat
    },
    data() {
      return {
        list: []
      }
    },
    methods   : {
      addChat(chat) {
        let index = this.list.findIndex(c => c.chat_id === chat.chat_id);
        if (index === -1) {
          this.list.push(Object.assign({}, chat, {idx: '' + new Date().getTime() + (Math.random() * 10000)}));
        }

      },
      closeChat(idx) {
        let index = this.list.findIndex(c => c.idx === idx);
        if (index > -1) {
          this.list.splice(index, 1);
        }
      }

    }
  }
</script>

<style scoped>
  .overlay {
    position : absolute;
    left     : 0;
    top      : 0;
    height   : 100%;
    width    : 100%;
    z-index  : -1;
  }

  .overlay.minimized {
    z-index : 1;
  }
</style>